import React from "react";

const Legal = ({texto,txtBoton,urlBoton}) => {
    const irUrlLink = () => {
        window.open(urlBoton, '_blank');
    }

    return (
            <div className="row legal">
                <div className="legal--txt">
                    <p>
                        {texto}
                    </p>
                </div>
                <div className="legal--btn">
                    <button className="btn-general btn-black" onClick={() => irUrlLink()}>
                        {txtBoton}
                    </button>
                </div>
            </div>
    );
};

export default Legal;